import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "plp-add-to-cart-modal" }
const _hoisted_2 = { class: "plp-add-to-cart-modal__variant-info" }
const _hoisted_3 = {
  key: 0,
  class: "plp-add-to-cart-modal__variant-info-title"
}
const _hoisted_4 = {
  key: 1,
  class: "plp-add-to-cart-modal__variant-info-title"
}
const _hoisted_5 = { class: "plp-add-to-cart-modal__image-container" }
const _hoisted_6 = { class: "plp-add-to-cart-modal__quantity-info" }
const _hoisted_7 = { class: "plp-add-to-cart-modal__quantity-info-title" }

import { ref, computed, onMounted, nextTick, watch } from 'vue';

import useContext from '@/composables/useContext';
import useLitium from '@/composables/useLitium';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useEventListener from '@/composables/useEventListener';
import useProduct from '@/composables/useProduct';
import useCustomerPrices from '@/composables/useCustomerPrices';

import DrawerLayer from '@distancify-storefront/ui-drawer-layer';
import AddToCart from '@/components/AddToCart.vue';

import ProductVariantSelector from '@/components/product/ProductVariantSelector.vue';
import ImageWithFallback from '@/components/ImageWithFallback.vue';

import PlpAddToCartModalPrices from '../PlpAddToCartModalPrices.vue';
import useUser from '@/composables/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlpAddToCartModal',
  setup(__props) {

const { user } = useUser();
const { route, navigateToLoginPage } = useContext();
const { toLitiumMediaUrl } = useLitium();
const { websiteText } = useWebsiteTexts();
const { useEmitterEventListener } = useEventListener();
const { getBaseProduct } = useProduct();

const { fetchPricesForProduct } = useCustomerPrices();

const isAddToCartOpen = ref(false);
const selectedQuantity = ref(0);

const productData = ref({});
const selectedVariant = ref({});
const singleVariantProduct = ref(true);

const unwatch: any = ref(null);

const displayName = computed(() => {
  return productData.value?.fieldsJson?._name || '';
});

const firstVariantImage = computed(() => {
  const image =
    selectedVariant.value?.images?.[0] || productData.value?.images?.[0];
  return toLitiumMediaUrl(image?.id, { maxWidth: 400 });
});

async function open(baseProductId: any) {
  if (user.value?.isAuthenticated) {
    await getProduct(baseProductId);

    unwatch.value = watch(
      () => selectedVariant.value,
      (variant) => {
        if (!variant) {
          return;
        }
        if (user.value?.isAuthenticated) {
          fetchPricesForProduct(variant.id);
        }
      },
      {
        immediate: true,
      }
    );

    isAddToCartOpen.value = true;
  } else if (!route.query?.action) {
    const search = route.query || {};
    const query = {
      ...search,
      action: 'add',
    };
    sessionStorage.setItem('baseProductId', baseProductId);
    navigateToLoginPage(query);
  }
}

function close() {
  if (unwatch.value) {
    unwatch.value();
  }
  isAddToCartOpen.value = false;
}

async function setSelectedVariant(variant: any) {
  selectedQuantity.value = 0;
  nextTick(() => (selectedQuantity.value = 1));

  await getProduct(productData.value.id, variant.id);
}

async function getProduct(baseProductId: string, variantId?: string) {
  const baseProduct = await getBaseProduct(baseProductId, variantId);
  productData.value = baseProduct;

  selectedVariant.value = baseProduct.selectedVariant;
  selectedQuantity.value =
    baseProduct.selectedVariant.purchaseQuantityFactor ||
    baseProduct.purchaseQuantityFactor ||
    1;

  if (baseProduct.variantsCount || baseProduct.variants.lengt) {
    singleVariantProduct.value =
      (baseProduct.variantsCount || baseProduct.variants.lengt) < 2;
  }
}

useEmitterEventListener('Category:AddToCart:Open', open);

onMounted(() => {
  if (sessionStorage.getItem('add-to-cart')) {
    sessionStorage.removeItem('add-to-cart');
    const baseProductId = sessionStorage.getItem('baseProductId');
    sessionStorage.removeItem('baseProductId');
    open(baseProductId);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DrawerLayer), {
    modelValue: isAddToCartOpen.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isAddToCartOpen).value = $event)),
    showCloseIcon: true,
    containerClass: "plp-add-to-cart-modal__container",
    modalClass: "add-to-cart__modal--center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!singleVariantProduct.value)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(websiteText)('product__action__choosevariant', {
              product: _unref(displayName),
            }).value), 1))
            : _createCommentVNode("", true),
          (singleVariantProduct.value)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_unref(displayName)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ImageWithFallback, {
              class: "plp-add-to-cart-modal__image",
              image: _unref(firstVariantImage),
              alt: selectedVariant.value?.fields?._name,
              loading: "lazy"
            }, null, 8, ["image", "alt"])
          ]),
          _createVNode(PlpAddToCartModalPrices, { "selected-variant": selectedVariant.value }, null, 8, ["selected-variant"]),
          _createVNode(ProductVariantSelector, {
            "product-data": productData.value,
            "selected-variant": selectedVariant.value,
            onSetSelectedVariant: setSelectedVariant,
            class: "plp-add-to-cart-modal__variant-select"
          }, null, 8, ["product-data", "selected-variant"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", _hoisted_7, _toDisplayString(_unref(websiteText)('product__stockstatus').value || 'product__stockstatus'), 1),
          (isAddToCartOpen.value)
            ? (_openBlock(), _createBlock(AddToCart, {
                key: 0,
                class: "plp-add-to-cart-modal__add-to-cart",
                "selected-quantity": selectedQuantity.value,
                "selected-variant": selectedVariant.value,
                onAddedToCart: _cache[0] || (_cache[0] = ($event: any) => (close()))
              }, null, 8, ["selected-quantity", "selected-variant"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})